import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { BulkPrintHistoryService } from 'common/data';

class BulkPrintHistoryStore extends BaseStore {
	constructor(rootStore) {
		super(new BulkPrintHistoryService(rootStore.app.baasic.apiClient));
	}

	@action async findBulkPrintHistory(filter) {
		const response = await this.service.find(filter);
		if (filter && filter.search) {
			response.data.searchQuery = filter.search;
		}
		this.response = response.data;
	}

	@action
	deleteBulkPrintHistory = async bph => {
		await this.service.delete(bph);
	};

	@action
	async createBulkPrintHistory(bph, sourceOfChange) {
		const response = await this.service.create(bph, sourceOfChange);
		this.item = response;
		return this.item.data;
	}

	@action
	async printBulkPrintHistory(bphItemId, sourceOfChange) {
		const response = await this.service.print(bphItemId, sourceOfChange);
		this.item = response;
	}
}

export default BulkPrintHistoryStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/BulkPrintHistoryStore.js